import { Link } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';

// ===== EN Related Sites hub — full redesign (mirrors JA; new design charter; _shared dropped) =====
// External official URLs unchanged. Route is registered in Layout.pagesWithOwnFaq (own FAQ rendered here).

const cards = [
  {
    name: 'THE BUTLER',
    role: 'Butler service',
    en: 'Butler Service',
    desc: 'A butler service operated by the Association. From the home to business and VVIP care, it is the gateway that supports daily life and hospitality comprehensively.',
    img: '/images/generated/jba-fs-194-related-v8.jpg',
    imgAlt: 'A butler serving in a luxury residence',
    internal: '/en/related/the-butler',
    external: 'https://thebutler.jp/',
  },
  {
    name: 'Butler Bell',
    role: 'Media brand',
    en: 'Media Brand',
    desc: 'The official media brand of Yuichi Ishii, the third chairman of the Association. Through the "Butler Bell" YouTube channel and more, it shares the true image of a butler and the spirit of hospitality.',
    img: '/images/generated/jba-fs-195-related.jpg',
    imgAlt: 'A butler offering hospitality in a reception room',
    internal: '/en/related/butler-bell',
    external: 'https://butlerbell.jp/',
  },
  {
    name: 'Japan Butler Academy',
    role: 'Training institution',
    en: 'Training Institution',
    desc: 'The education and training institution operated by the Association. It trains butlers through a structured curriculum and awards Association-certified credentials to those who complete the program.',
    img: '/images/generated/jba-fs-196-related-v8.jpg',
    imgAlt: 'Training in butler etiquette and conduct',
    internal: '/en/related/butler-academy',
    external: 'https://butler-academy.jp/',
  },
];

const faqs = [
  {
    q: 'What are the related sites?',
    a: 'This is a guide to the organizations and brands that support butler culture, centered on the Japan Butler Association. It introduces three sites: the butler service THE BUTLER, the media brand Butler Bell, and the training institution Japan Butler Academy.',
  },
  {
    q: 'How is each site related to the Japan Butler Association?',
    a: 'THE BUTLER and Japan Butler Academy are the service and institution operated by the Association. Butler Bell is the official media brand of the third chairman, Yuichi Ishii, sharing butler culture with society through YouTube and other outlets. All three are related sites that support the learning, communication, and practice of the butler craft.',
  },
  {
    q: 'Where can I find each official page?',
    a: 'Use "Learn more" on each card to open its introduction page within our site, and "Official site" to open each external official page in a new window. The addresses are thebutler.jp, butlerbell.jp, and butler-academy.jp.',
  },
];

const breadcrumbs = [{ label: 'Home', href: '/en/' }, { label: 'Related Sites' }];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.06em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function EnRelatedHubPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[480px] lg:min-h-[540px] flex items-center">
        <img src="/images/generated/jba-space-room-02.jpg" alt="Salon hall with a chandelier" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Related Organizations</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.02em] mb-6">
              <span className="block">The Association group</span>
              <span className="block">behind butler culture</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.9]">
              Centered on the Japan Butler Association, the organizations and brands that support butler culture work together, connecting learning, communication, and real-world practice into a single flow. Here we introduce each one and its connection to the Association.
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* I. Our Network */}
      <NavyBand no="I" ja="The whole picture of the group" en="Our Network" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
                From learning to practice, <span className="text-[#a38e65]">as a single flow</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                The work of the Japan Butler Association does not stand alone. Centered on the Association, which handles the training, certification, and corporate programs for butlers, a brand that shares butler culture with society and a brand that delivers actual butler services work together, connecting learning and practice into one flow.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
                This page introduces the butler-related sites closely tied to the Association: THE BUTLER, Butler Bell, and Japan Butler Academy. For each, we explain its role and its connection to the Association, so you can see the wider picture of the butler profession.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-interior-wardrobe-02.jpg" alt="Furnishings and a china cabinet in the butler salon" className="w-full h-[300px] sm:h-[400px] md:h-[460px] object-cover object-top border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* II. Related Sites */}
      <NavyBand no="II" ja="Three butler-related sites" en="Related Sites" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {cards.map((card) => (
              <article key={card.internal} className="group flex flex-col bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 sm:h-56 overflow-hidden">
                  <img src={card.img} alt={card.imgAlt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-4 left-4 bg-[#1a2942]/90 text-[#d7b779] text-[11px] tracking-[0.08em] px-3 py-1 border border-[#a38e65]/40">{card.role}</span>
                </div>
                <div className="flex flex-col flex-1 p-7 sm:p-8 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm tracking-[0.06em] mb-2">{card.en}</span>
                  <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl leading-[1.4] mb-4">{card.name}</h3>
                  <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] mb-6 flex-1">{card.desc}</p>
                  <div className="flex flex-col gap-3 pt-5 border-t border-[#e2ddd2]">
                    <Link to={card.internal} className="inline-flex items-center gap-2 font-['Noto_Serif_JP',serif] text-[15px] text-[#1a2942] tracking-[0.04em] border-b border-[#a38e65] pb-1 self-start hover:text-[#8f7a56] transition-colors duration-300">
                      Learn more <span className="text-[#a38e65] group-hover:translate-x-1 transition-transform">→</span>
                    </Link>
                    <a href={card.external} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56] hover:text-[#a38e65] transition-colors self-start">
                      Official site <i className="ri-external-link-line text-xs"></i>
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* III. Relationship */}
      <NavyBand no="III" ja="How the Association and sites connect" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[420px] bg-black order-1">
              <img src="/images/generated/jba-fs-197-related-v8.jpg" alt="A butler network where learning, communication, and practice connect under the Association" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">How We Are Connected</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.01em] mb-6">
                Connected under <span className="text-[#d7b779]">one Association</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9]">
                The Japan Butler Association serves as the operating body. Its butler service is THE BUTLER and its training institution is Japan Butler Academy. The official media brand of the third chairman, Yuichi Ishii, is Butler Bell. Learning, communication, and practice are all connected under one Association.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV. FAQ */}
      <NavyBand no="IV" ja="Frequently asked questions" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 md:p-14 text-center">
            <h3 className="jba-display font-medium text-2xl sm:text-3xl text-[#f8f6f0] tracking-[0.02em]">Interested in learning the butler craft?</h3>
            <div className="w-11 h-px bg-[#a38e65] mx-auto mt-4 mb-6"></div>
            <p className="text-base sm:text-lg text-[#e7e2d8] mb-8 font-['Noto_Serif_JP',serif] max-w-2xl mx-auto leading-[1.85]">For questions about our certification programs, corporate training, or services, please feel free to contact us.</p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/en/qualifications" className={BTN08_ON_NAVY}>View certifications</Link>
              <Link to="/en/contact" className={BTN08_ON_NAVY}>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
